import { Loader } from '@mantine/core';
import { useBasketQr } from '../useBasketQr';
import type { DigitalMenuBasketLine } from '../digital-menu.utils';
import classes from '../digital-menu.module.scss';

export function BasketQr({ tenantId, lines }: { tenantId: string; lines: DigitalMenuBasketLine[] }) {
  const { image, error } = useBasketQr(tenantId, lines);
  return <section className={classes.basketQr} aria-label="קוד הסל למלצר">
    {error ? <p role="alert">{error}</p> : image ? <img src={image} alt="קוד הסל למלצר" /> : <Loader size="sm" color="gray" />}
  </section>;
}